import { render, staticRenderFns } from "./Matriz1.vue?vue&type=template&id=1b968674&scoped=true&"
import script from "./Matriz1.vue?vue&type=script&lang=js&"
export * from "./Matriz1.vue?vue&type=script&lang=js&"
import style0 from "./Matriz1.vue?vue&type=style&index=0&id=1b968674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b968674",
  null
  
)

export default component.exports